import Dexie, { type EntityTable } from 'dexie';
import {getConfig} from "../../AppConfig";
const { dbversionwr } = getConfig()

interface workreporting {
    uuid: string; // This prop will be used as primary key (see below)
    json: string;
}

const db = new Dexie(dbversionwr) as Dexie & {
    workreporting: EntityTable<workreporting, 'uuid'>
};

// Schema declaration:
// db.version(2).stores({
//     dispatch: '++uuid, uuid, json'
// });
// Don't touch this version unless you change the schema
db.version(1).stores({
    workreporting: '++uuid, uuid, json'
});

db.version(2).stores({
    workreporting: '++uuid, uuid, json'
});

db.version(3).stores({
    workreporting: '++uuid, uuid, json'
});

export type { workreporting };
export { db };